<div class="drawer-item-wrap">
    <div [id]="'nav-' + entity().id" class="drawer-item" [class.active]="isActive()" (click)="selectEntity()">
        <div class="drawer-item-content">
            <small
                class="sp-icon icon-chevron-right"
                style="display: block"
                [style.rotate]="showChildren() ? '90deg' : '0deg'"
            >
            </small>

            <img src="./assets/img/websites/lpc-structure-icon.svg" alt="lpc-structure-icon" />

            <div class="text-wrapper">
                <div class="text-item">{{ "control_structure" | translate }}</div>
                <div class="id-item" [title]="'id: ' + displayId()">id: {{ displayId() }}</div>
            </div>
        </div>
    </div>
    @if (showActions()) {
        <div dropdown #dropdown="bs-dropdown" class="btn-group dropdown dropdown-options">
            <button
                dropdownToggle
                type="button"
                class="btn btn-action dropdown-toggle"
                aria-haspopup="true"
                aria-expanded="false"
            >
                <span class="sp-icon icon-ellipsis"></span>
            </button>

            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="button-basic">
                <li role="menuitem">
                    <a class="dropdown-item" (click)="copyGrid()">
                        <span class="sp-icon icon-copy"> </span>
                        {{ "duplicate" | translate }}
                    </a>
                </li>
                <li>
                    <hr />
                </li>
                <li role="menuitem" (click)="removeGrid()">
                    <a>
                        <span class="sp-icon icon-bin color-danger"></span>
                        {{ "delete" | translate }}
                    </a>
                </li>
            </ul>
        </div>
    }
</div>

@if (showChildren()) {
    <div class="drawer-item-children">
        @for (row of rows(); let gridIndex = $index; track gridIndex) {
            @for (widget of row; let widgetIndex = $index; track widgetIndex) {
                <web-navigation-grid-widget-item
                    [entity]="widget"
                    [index]="widgetIndex"
                    [structureIndex]="gridIndex"
                    [selectedEntity]="selectedEntity()"
                    (widgetSelected)="onChildWidgetSelected()"
                />
            }
        }
    </div>
}
